export default function (app, config) {
    app.factory('Calendar', ['$http',
        function($http) {
            return {
                get: function (centerId, from, to) {
                    return $http({
                        url: config.END_POINT + 'centers/' + centerId + '/calendar?from=' + from + '&to=' + to,
                        transformResponse: function(data){
                            data = JSON.parse(data);
                            data.forEach(function(day){
                                var match = day.date.match(/(\d+)-(\d+)-(\d+)/);
                                day.year = parseInt(match[1], 10);
                                day.month = parseInt(match[2], 10) - 1;
                                day.day = parseInt(match[3], 10);
                                day.group_ids = [];
                                day.group_therapies.forEach(function(gt){
                                    day.group_ids.push(gt.group_id);
                                });
                            });
                            return data;
                        }
                    });
                },
                generate: function(centerId, from, to, group_ids){
                    return $http({
                        url: config.END_POINT + 'centers/' + centerId + '/calendar',
                        method: 'POST',
                        data: {
                            from: from,
                            to: to,
                            group_ids: group_ids
                        }
                    });
                },
                print: function(centerId, from, to){
                    return $http({
                        url: config.END_POINT + 'centers/' + centerId + '/calendar.pdf' +
                            '?from=' + from + '&to=' + to,
                        method: 'GET',
                        responseType: "blob"
                    });
                }
            };
        }
    ]);
};



// WEBPACK FOOTER //
// ./js/calendar/calendarResource.js